<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">Examine the IR spectrum provided for compound E.</p>
      <p class="mb-2">
        Based on the molecular formula, the UN/DBE you calculated, and the IR spectrum, check all
        the functional groups that are definitely not present in compound E.
      </p>

      <p v-for="option in optionsShuffled" :key="option.value" class="mb-0 mt-0">
        <v-checkbox v-model="inputs.studentAnswers" :value="option.value" class="ml-6 mb-n4 mt-0">
          <template v-slot:label>
            <stemble-latex :content="option.text" />
          </template>
        </v-checkbox>
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import {seededShuffle} from '@/courses/utils/seededShuffle';

export default {
  name: 'ChemUCI51LBA2M5Q1',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswers: [],
      },
      options: [
        {text: 'alcohol', value: 'alcohol'},
        {text: 'aldehyde', value: 'aldehyde'},
        {text: 'ester', value: 'ester'},
        {text: 'nitrile', value: 'nitrile'},
        {text: 'alkene', value: 'alkene'},
        {text: 'ring', value: 'ring'},
        {text: 'amine', value: 'amine'},
        {text: 'ketone', value: 'ketone'},
        {text: 'carboxylic acid', value: 'acid'},
        {text: 'benzene ring', value: 'benzene'},
        {text: 'alkyne', value: 'alkyne'},
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
  },
};
</script>
